module.exports = __webpack_public_path__ + "img/RAS-Pro.a6df29ad.png";